import { IRespostaFuncao } from 'src/integracoes/modelos/funcoes';
import { del, get, post, patch } from "../../api/api";

// Listar campanhas por empresa
export const listarCampanhas = async (empId: string) => {
  return await get<IRespostaFuncao<any[]>>(`/empresas/${empId}/campanhas`);
};

// Listar campanha por Id
export const listarCampanha = async (campanhaId: string) => {
  return await get<IRespostaFuncao<any[]>>(`/campanhas/${campanhaId}`);
};

// Criar campanha
export const criarCampanha = async (
  payload: any
): Promise<IRespostaFuncao<any>> => {
  return await post<IRespostaFuncao<any>>(
    `/campanhas/cria-campanha`,
    payload
  );
};

// Atualizar campanha
export const atualizarCampanha = async (
  campanhaId: string,
  payload: any
): Promise<IRespostaFuncao<any>> => {
  return await patch<IRespostaFuncao<any>>(
    `/campanhas/${campanhaId}/atualiza-campanha`,
    payload
  );
};

// Duplicar campanha
export const duplicarCampanha = async (
  campanhaId: string
): Promise<IRespostaFuncao<any>> => {
  return await post<IRespostaFuncao<any>>(
    `/campanhas/${campanhaId}/duplica-campanha`,
    {}
  );
};

// Deletar campanha
export const deletarCampanha = async (
  campanhaId: string
): Promise<IRespostaFuncao<any>> => {
  return await del<IRespostaFuncao<any>>(
    `/campanhas/${campanhaId}/remove-campanha`
  );
};
